// En src/services/api/http.js
import axios from "axios";
import { sessionState } from "@/state/sessionState";
import AuthService from "@/services/auth/auth.js";

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL || process.env.VUE_APP_API_BASE_URL || process.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Interceptor de Peticiones (Request)
http.interceptors.request.use(
  (config) => {
    // ¡Aquí está la magia! Dejamos que AuthService haga el trabajo pesado
    const token = AuthService.getJWTToken();
    const csrfToken = AuthService.getCSRFToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (csrfToken) {
      config.headers["X-CSRFToken"] = csrfToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Interceptor de Respuestas (Response)
http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("Soft Lock Activado por Axios: Sesión Expirada");
      sessionState.isSoftLocked = true;
    }
    return Promise.reject(error);
  },
);

export default http;
